<!-- 首页-预约appointment-页面级 -->
<template>
  <div class='appoint-container'>
    <!--预约待确认-->
    <div class='appoint-list'
         v-if='unconfirmList.length > 0'>
      <h3 class='appoint-title'>Appointment - please confirm<span>{{unconfirmList.length}}</span></h3>
      <ul class='appoint-module clearfix'>
        <li v-for='modal in unconfirmList'
            :key='modal.id'
            class='fl'
            @click="confirm(modal)">
          <h4 class='module-title'>{{modal.module && new Map(packageModuleMap).get(modal.module)}}</h4>
          <p class='module-mentee'>Mentee {{modal.menteeName}}</p>
          <p class='zone'>Mentee proposed time：({{modal.menteeZone | zoneEnFilter}})</p>
          <div class='time'
               v-for='(time, index) in modal.createTrack.content'
               :key='index'>
            <span>{{time.minTimeStr}} - {{time.maxTimeStr}}</span>
            <!-- <span v-if='index === 0'>（priority）</span> -->
          </div>
        </li>
      </ul>
    </div>
    <!--预约未开始-->
    <div class='appoint-list'
         v-if='waitingList.length > 0'>
      <h3 class='appoint-title'>Appointment - In progress<span>{{waitingList.length}}</span></h3>
      <ul class='appoint-module clearfix'>
        <li v-for='modal in waitingList'
            :key='modal.id'
            :class="[modal.hasTime ? '' : 'active', 'fl']"
            @click="waiting(modal)">
          <h4 class='module-title'>{{modal.module && new Map(packageModuleMap).get(modal.module)}}</h4>
          <p class='module-mentee'>Mentee {{modal.menteeName}}</p>
          <div class='time'>
            <span>{{modal.mentorResultTimeStr}} ({{modal.mentorZone | zoneEnFilter}})</span>
          </div>
          <!-- <div class='diff-time'>距离活动开始还有{{modal.leftTime}}小时</div> -->
          <div class='diff-time'>Appointment starts in {{modal.remaining}}</div>
        </li>
      </ul>
    </div>
    <!--预约待反馈-->
    <div class='appoint-list'
         v-if='feedbackList.length > 0'>
      <h3 class='appoint-title'>Appointment - please provide feedback<span>{{feedbackList.length}}</span></h3>
      <ul class='appoint-module clearfix'>
        <li v-for='modal in feedbackList'
            :key='modal.id'
            class='fl'
            @click="feedback(modal)">
          <h4 class='module-title'>{{modal.module && new Map(packageModuleMap).get(modal.module)}}</h4>
          <p class='module-mentee'>Mentee {{modal.menteeName}}</p>
          <div class='time'>
            <span>{{modal.mentorResultTimeStr}} ({{modal.mentorZone | zoneEnFilter}})</span>
          </div>
        </li>
      </ul>
    </div>
    <!--预约已完成-->
    <div class='appoint-list'
         v-if='finishedList.length > 0'>
      <h3 class='appoint-title'>Appointment - Complete</h3>
      <ul class='appoint-module clearfix'>
        <li v-for='(modal, index) in finishedList'
            :key='index'
            class='fl'
            @click="finish(modal)">
          <h4 class='module-title'>{{modal.module && new Map(packageModuleMap).get(modal.module)}}</h4>
          <p class='module-mentee'>Mentee {{modal.menteeName}}</p>
          <div class='time'>
            <span>{{modal.mentorResultTimeStr}} ({{modal.mentorZone | zoneEnFilter}})</span>
          </div>
          <div class='diff-time'>Appointment - Complete</div>
        </li>
      </ul>
    </div>
    <!--预约待确认弹窗-->
    <div v-if='appointmentModal'>
      <appoint-modal ref='appointModal'
                     :isShow='appointmentModal'
                     :uncomfirmId='uncomfirmId'
                     :hasConfirm='hasConfirm'
                     @closeModal='closeAppoint'
                     @appointModalOk='appointOk'
                     defaultWidth='800px' />
    </div>
    <!--预约待反馈弹窗-->
    <div v-if="feedModal">
      <feedback-modal ref='backModal'
                      :isShow='feedModal'
                      :feedbackId='feedbackId'
                      :hasFeedback='hasFeedback'
                      @closeModal='closeFeedback'
                      @feedbackModalOk='feedbackOk'
                      defaultWidth='801px' />
    </div>
    <!--预约已完成弹窗-->
    <div v-if="finishedModel">
      <finish-modal :isShow='finishedModel'
                    :finishId='finishId'
                    @closeModal='closeFinish'
                    defaultWidth='800px' />
    </div>
  </div>
</template>

<script>
import menteeService from '@/api/undergraduate/mentee'
import appointmentService from '@/api/undergraduate/appointment'
import appointModal from './components/appoint-modal'
import feedbackModal from './components/feedback-modal'
import finishModal from './components/finish-modal'
import { packageModuleMap, zoneEnMap } from './constants'
import { mapMutations } from 'vuex'
export default {
  name: '',
  filters: {
    zoneEnFilter (value) {
      let find = zoneEnMap.find(o => o.value === value)
      if (find) {
        return find.title
      }
      return ''
    }
  },
  components: {
    appointModal,
    feedbackModal,
    finishModal
  },
  data () {
    return {
      // 套餐模块映射
      packageModuleMap,
      // 时区映射
      zoneEnMap,
      // 预约未确认
      unconfirmList: [],
      // 预约待确认ID
      uncomfirmId: -1,
      // 待确认-loading标识， 避免重复提交
      hasConfirm: false,
      // 预约未开始
      waitingList: [],
      // 预约待反馈
      feedbackList: [],
      // 待反馈-loading标识， 避免重复提交
      hasFeedback: false,
      // 预约待反馈ID
      feedbackId: -1,
      // 活动已完成
      finishedList: [],
      // 活动已完成ID
      finishId: -1,
      // 预约弹窗标识
      appointmentModal: false,
      // 反馈弹窗标识
      feedModal: false,
      // 已完成弹窗标识
      finishedModel: false,
      // 学员num
      menteeNum: ''
    }
  },
  computed: {},
  mounted () {
    this.menteeNum = this.$route.params.id
    // 获取各种预约列表
    this.getUncomfirmList()
    this.getUnfinishedList()
    this.getTofeedbackList()
    this.getFinishedList()
    this.getActivityTabs()
  },
  methods: {
    // 获取任务数量
    getActivityTabs (state, tabs) {
      menteeService
        .taskNums({ menteeNum: this.menteeNum })
        .then(res => {
          // mutations 操作
          this.setActivityTabs(res.data.model)
        })
        .catch(error => {
          this.$ugd_message(error.message, 'error')
        })
    },
    // 预约待确认列表
    getUncomfirmList () {
      appointmentService.appointUncomfirmList({ menteeNum: this.menteeNum }).then(res => {
        this.unconfirmList = res.data.model
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 预约未开始列表
    getUnfinishedList () {
      appointmentService.appointUnfinishedList({ menteeNum: this.menteeNum }).then(res => {
        let list = res.data.model
        // 剩余时间处理
        let temp = []
        list.length > 0 && list.map(item => {
          temp.push({
            ...item,
            ...this.diffTime(item.mentorResultTimeStr, 1)
          })
        })
        this.waitingList = temp
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 预约待反馈列表
    getTofeedbackList () {
      appointmentService.appointTofeedbackList({ menteeNum: this.menteeNum }).then(res => {
        this.feedbackList = res.data.model
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 预约已完成列表
    getFinishedList () {
      appointmentService.appointFinishedList({ menteeNum: this.menteeNum }).then(res => {
        let list = res.data.model
        // 剩余时间处理
        let temp = []
        list.length > 0 && list.map(item => {
          temp.push({
            ...item,
            ...this.diffTime(item.mentorResultTimeStr, 1)
          })
        })
        this.finishedList = temp
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 处理剩余时间
    diffTime (val, range) {
      let date = (new Date(val) - new Date()) / 1000 / 60 / 60 / 24
      if (date >= range) {
        return {
          hasTime: true
        }
      } else {
        return {
          hasTime: false
        }
      }
      // else if (date * 24 >= 1) {
      //   return `${parseInt(date * 24)}小时`
      // } else if(date * 24 >= 1)
    },
    // 预约待确认-点击
    confirm (item) {
      this.uncomfirmId = item.id
      this.appointmentModal = true
    },
    // 关闭预约待确认弹窗
    closeAppoint () {
      this.appointmentModal = false
    },
    // 提交预约待确认操作
    appointOk (forms) {
      this.hasConfirm = true
      appointmentService.appointUncomfirmSub(forms).then(res => {
        this.$refs.appointModal.resetStatus()
        this.appointmentModal = false
        this.hasConfirm = false
        // 重新调用列表
        this.getUncomfirmList()
        this.getUnfinishedList()
        this.getTofeedbackList()
        this.getFinishedList()
        this.getActivityTabs()
        this.$ugd_message('Appoint success', 'success')
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
        this.hasConfirm = false
      })
    },
    // 预约未开始-点击
    waiting (item) {
      this.$router.push({
        path: `/undergraduate/mentee/${this.menteeNum}/activity/appointment/${item.id}`
      })
    },
    // 预约待反馈-点击
    feedback (item) {
      this.feedbackId = item.id
      this.feedModal = true
    },
    // 关闭预约未开始弹窗
    closeFeedback () {
      this.feedModal = false
    },
    // 提交-预约待反馈操作
    feedbackOk (forms) {
      this.hasFeedback = true
      appointmentService.appointFeedbackSub(forms).then(res => {
        this.$ugd_message('Feedback success', 'success')
        this.$refs.backModal.resetStatus()
        // 重新调用列表
        this.getUncomfirmList()
        this.getUnfinishedList()
        this.getTofeedbackList()
        this.getFinishedList()
        this.getActivityTabs()
        this.feedModal = false
        this.hasFeedback = false
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
        this.hasFeedback = false
      })
    },
    // 预约已结束-点击
    finish (item) {
      this.finishId = item.id
      this.finishedModel = true
    },
    // 关闭预约已结束弹窗
    closeFinish () {
      this.finishedModel = false
    },
    ...mapMutations({
      'setActivityTabs': 'setActivityTabs'
    })
  }
}
</script>
<style lang='less' scoped>
.clearfix {
  *zoom: 1;
}
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
.fl {
  float: left;
}
.appoint-container {
  padding-top: 20px;
  .appoint-list {
    .appoint-title {
      font-size: 18px;
      color: #4aa6ff;
      letter-spacing: 0;
      text-align: left;
      padding-left: 20px;
      span {
        font-size: 18px;
        color: #b1bcc8;
        letter-spacing: 0;
        margin-left: 30px;
      }
    }
    .appoint-module {
      li {
        background: #ffffff;
        border-radius: 8px;
        padding: 0 10px;
        width: 360px;
        height: 170px;
        margin: 20px;
        position: relative;
        cursor: pointer;
        text-align: center;
        .module-title {
          font-size: 16px;
          color: #323c47;
          padding-top: 10px;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .module-mentee {
          font-size: 14px;
          font-weight: bold;
          color: #323c47;
          line-height: 24px;
          padding-bottom: 10px;
        }
        .time {
          font-size: 12px;
          color: #667483;
        }
        .diff-time {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 40px;
          background: #eaf1fd;
          border-radius: 0 0 8px 8px;
          font-size: 12px;
          color: #667483;
          letter-spacing: 0;
          text-align: center;
          line-height: 40px;
        }
        &.active {
          background: #fff5f2;
          .diff-time {
            background: #ffded4;
            color: #687584;
          }
        }
      }
    }
  }
}
</style>
